<template>
    <v-data-table
        :headers="headers"
        :items="list"
        dense
        :options="options"
        @update:options="updateOptions"
        :footer-props="footer"
        :server-items-length="length"
        :loading="loading"
    >
        <template v-slot:[`item.code`]="{item}">
            <v-btn icon @click="handleClickRow(item)" v-if="hasPermission(perm.warehouse.read)">
                <v-icon>mdi-magnify</v-icon>
            </v-btn>
            {{item.code}}
        </template>

    </v-data-table>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import permission from './../../data/permissions';
export default {
    name: "WarehouseList",
    data() {
        return {
            headers: [
                { text: "Code", value: "code" },
                { text: "Warehouse", value: "name" },
                { text: "Description", value: "description"}
            ],
            footer: {
                'items-per-page-options': [5, 10, 15]
            },
            perm: permission
        }
    },
    computed : {
        ...mapGetters({
            list: "warehouse/warehouse/list/data",
            options: "warehouse/warehouse/list/options",
            loading: "warehouse/warehouse/list/loading",
            length: "warehouse/warehouse/list/length",
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            updateOptions: "warehouse/warehouse/list/updateOptions"
        }),
        handleClickRow(item){  
            this.$router.push({ name: 'WarehouseDisplay', params: { id: item.id}})
        }
    }
}
</script>

<style>
</style>